var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "modalArea", class: { "modal-area": true, active: _vm.reportOpen } },
    [
      _c("div", { staticClass: "modal" }, [
        _c("div", { staticClass: "close-modal" }, [
          _c("i", { staticClass: "bx bx-x", on: { click: _vm.closeModal } }),
        ]),
        _vm._v(" "),
        _c("div", { ref: "modalInner", staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("project.report_type")) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "m-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.type,
                    expression: "form.type",
                  },
                ],
                staticClass: "m-field-input",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "type",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              _vm._l(_vm.types, function (type, ind) {
                return _c(
                  "option",
                  { key: ind, domProps: { value: type.value } },
                  [
                    _vm._v(
                      "\n            " + _vm._s(type.label) + "\n          "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("i", { staticClass: "bx bxs-chevron-down m-down-icon" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "m-field" }, [
            _c("textarea", {
              staticClass: "m-field-input report-textarea",
              attrs: {
                rows: "4",
                placeholder: _vm.$t("project.reason") + "...",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "buttons-area" }, [
            _c(
              "button",
              {
                staticClass: "button stroke-button",
                attrs: { type: "button" },
                on: { click: _vm.closeModal },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("common.cancel")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.loading
              ? _c(
                  "button",
                  {
                    staticClass: "button filled-button",
                    attrs: { type: "button" },
                    on: { click: _vm.sendReport },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.apply")) +
                        "\n        "
                    ),
                  ]
                )
              : _c("div", { staticClass: "button filled-button" }, [
                  _c("i", { staticClass: "bx bx-loader-alt loading" }),
                ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }